export default __webpack_public_path__ + "static/media/Malawi_logo_3.65c339f3.png";